module.exports = __webpack_public_path__ + "static/media/minus-circle.064be954.svg";